import CardService from '../../shared/services/card-service';

export default {
    methods: {
        moreThanOneCards: function (cards) {
            var self = this;
            CardService.getSavedCards(cards).then((res) => {
                if (res && res.data) {
                    self.cards = res.data;
                }
                else {
                    console.log("CARDS DOES NOT EXIST, SO ADD IT TO THE ADMIN");
                }
            });
        }
    }
};